function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { map } from 'rxjs';
import { useObservable } from 'rxjs-hooks';
import { Preloader } from '@procom-labs/atoms';
import { AuthPortalRouteMaps, capitalize, ClientQueryParams, LoginTypes, PageNotFound, useAuthService } from '@procom-labs/common';
export var RedirectAuthPortal = function(param) {
    var strictLoginType = param.strictLoginType, _param_nonRedirectRoutes = param.nonRedirectRoutes, nonRedirectRoutes = _param_nonRedirectRoutes === void 0 ? [] : _param_nonRedirectRoutes, _param_withoutParams = param.withoutParams, withoutParams = _param_withoutParams === void 0 ? false : _param_withoutParams;
    var location = useLocation();
    var _useSearchParams = _sliced_to_array(useSearchParams(), 1), searchParams = _useSearchParams[0];
    var loginTypeParam = searchParams.get(ClientQueryParams.loginType);
    var storedLoginType = localStorage.getItem('loginType');
    var loginType = loginTypeParam || storedLoginType ? capitalize(loginTypeParam || storedLoginType || '') : LoginTypes.Client;
    var authService = useAuthService();
    var isAuthenticated = useObservable(function() {
        return authService.currentUser$.pipe(map(function(user) {
            return !!user;
        }));
    });
    var from = !withoutParams ? "".concat(location.pathname).concat(location.search || '') : undefined;
    var isRedirect = useMemo(function() {
        return from === '/' || from === undefined || !nonRedirectRoutes.includes(from) || !isAuthenticated;
    }, [
        from,
        isAuthenticated,
        nonRedirectRoutes
    ]);
    useEffect(function() {
        if (isRedirect) {
            authService.redirectToAuthPortal(from, AuthPortalRouteMaps.Login, strictLoginType || loginType);
        }
    }, [
        from,
        loginType,
        isRedirect,
        strictLoginType
    ]);
    return isRedirect ? /*#__PURE__*/ _jsx(Preloader, {
        center: true
    }) : /*#__PURE__*/ _jsx(Navigate, {
        to: PageNotFound
    });
};
